var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(false)?_c('home-header'):_vm._e(),(false)?_c('side-contact'):_vm._e(),_c('main',[_c('router-view')],1),(false)?_c('home-footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }